import * as React from "react"
import Svg, { Path } from "react-native-svg"

function ImagePlaceholder(props) {
  return (
    <Svg width={49} height={40} xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M49 40H0V0h49v40zM46.958 2H2.042v36h44.916V2zm-2.041 32H6.125l8.167-14.984 6.125 6.096L30.652 10l14.265 24zm-24.19-5.73l-5.941-5.912L9.53 32h31.835L30.54 13.784 20.727 28.27zM11.229 6c2.818 0 5.104 2.24 5.104 5s-2.286 5-5.104 5c-2.817 0-5.104-2.24-5.104-5s2.287-5 5.104-5zm0 2c1.69 0 3.063 1.344 3.063 3s-1.372 3-3.063 3c-1.69 0-3.062-1.344-3.062-3s1.372-3 3.062-3z"
        fill="#114D00"
        fillRule="evenodd"
      />
    </Svg>
  )
}

export default ImagePlaceholder
